// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"verify"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 20V4L2 4L2 20H22Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 20V4L2 4L2 20H22Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 10H8.5M6 14H8.5M12.5 15.5C12.5 13.8431 13.8431 12.5 15.5 12.5M15.5 12.5C17.1569 12.5 18.5 13.8431 18.5 15.5M15.5 12.5C16.6046 12.5 17.5 11.6046 17.5 10.5C17.5 9.39543 16.6046 8.5 15.5 8.5C14.3954 8.5 13.5 9.39543 13.5 10.5C13.5 11.6046 14.3954 12.5 15.5 12.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const VerifyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'verify',
    ref,
    icon: element,
  },
));

VerifyIcon.displayName = 'VerifyIcon';

export default VerifyIcon;
